import type { ConflictCode } from '../../services/api/types.gen';
import { getConflictCode } from '../../utils/apiErrorDetail';

/**
 * Map the one-SOC-per-episode refusal to user-facing copy (EMR-1313).
 *
 * The server `detail` is intentionally never surfaced (see
 * `.cursor/rules/error-handling.mdc`); we key off the stable `code`.
 */
const COPY_BY_CODE: Partial<Record<ConflictCode, string>> = {
  EPISODE_ALREADY_HAS_SOC:
    'This episode already has a Start of Care. Delete it or mark it missed before scheduling another.',
  MULTIPLE_SOC_IN_BATCH:
    'You can only schedule one Start of Care per episode. Remove the extra before creating.',
};

export function socConflictCopy(
  code?: ConflictCode | string | null
): string | undefined {
  if (!code) return undefined;
  return COPY_BY_CODE[code as ConflictCode];
}

/** Read a 409 body (or a thrown client error wrapping one) and return SOC copy. */
export function socConflictCopyFromError(error: unknown): string | undefined {
  if (!error || typeof error !== 'object') {
    return socConflictCopy(getConflictCode(error));
  }
  const obj = error as {
    error?: unknown;
    response?: { data?: unknown };
  };
  return (
    socConflictCopy(getConflictCode(error)) ??
    socConflictCopy(getConflictCode(obj.error)) ??
    socConflictCopy(getConflictCode(obj.response?.data))
  );
}
